import { createApp } from 'vue'

import Cookies from 'js-cookie'

import ElementPlus from 'element-plus'

import '@/assets/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import draggable from 'vuedraggable';
import directive from './directive' // directive
import SocketService from './utils/websocket' // 对服务端进行websocket连接
import MQTTService from './utils/mqtt';
import i18n  from './i18n/i18n'
import partitionDrag from 'partition-drag';  

// 注册指令
import plugins from './plugins' // plugins
import { download, downloadPost } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/SvgIcon'
import elementIcons from '@/components/SvgIcon/svgicon'
import "@/assets/font/icon-font/iconfont.css"; // 字体图标
import './permission' // permission control
import { forceReload, clearForceReloadParam } from '@/utils/forceReload' // 强制刷新(绕过浏览器缓存)

import { useDict } from '@/utils/dict'
import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels, i18nConfig } from '@/utils/ruoyi'

// gljy自定义组合组件
import gljy from "./component/index.js"; // 封装组件加载进来
// 分页组件
import Pagination from '@/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 自定义树选择组件
import TreeSelect from '@/components/TreeSelect'
// 字典标签组件
import DictTag from '@/components/DictTag'

import '@/assets/scss/index.scss'; // 字体

import vue3videoPlay from 'vue3-video-play' // 引入组件
import 'vue3-video-play/dist/style.css' // 引入css

const app = createApp(App)

// 全局方法挂载
app.config.globalProperties.useDict = useDict
app.config.globalProperties.download = download
app.config.globalProperties.downloadPost = downloadPost
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
app.config.globalProperties.$socket = SocketService.Instance
app.config.globalProperties.$MQTTService = MQTTService.Instance
app.config.globalProperties.$i18nConfig = i18nConfig

// 全局组件挂载
app.component('DictTag', DictTag)
app.component('Pagination', Pagination)
app.component('TreeSelect', TreeSelect)
app.component('FileUpload', FileUpload)
app.component('ImageUpload', ImageUpload)
app.component('ImagePreview', ImagePreview)
app.component('RightToolbar', RightToolbar)
app.component("draggable", draggable);

app.use(router)
app.use(store)
app.use(i18n)
app.use(plugins)
app.use(elementIcons)
app.use(gljy)
app.use(partitionDrag)
app.use(vue3videoPlay)
app.component('svg-icon', SvgIcon)

directive(app)

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  // 支持 large、default、small
  size: Cookies.get('size') || 'default'
})

// 强制刷新兜底(与 permission.js 中的 router.onError 配合)
// Vite 动态 import 预加载失败时的事件,发版后旧页面引用的 js 已被删除时会触发,
// 这里拦截后强制刷新,避免页面卡在空白/无响应状态
window.addEventListener('vite:preloadError', (event) => {
  // event.payload 为空说明是构建期的真实错误(生产环境不会出现),不做处理
  if (event.payload) {
    // 阻止 vite 默认的错误提示
    event.preventDefault()
    forceReload('页面已更新,正在自动刷新...')
  }
})

app.mount('#app')

// 清理强制刷新时残留在地址栏上的 _v 参数
// 必须等路由初始化完成后再执行,并且 clearForceReloadParam 内部会保留 history.state,
// 否则会破坏 vue-router 维护的内部状态
router.isReady().then(() => {
  clearForceReloadParam()
})
